import { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import useSession from '../hooks/useSession';
import authAPI from '../services/auth';
import { UserContext } from '../context/UserContext';
import projectAPI from '../services/project';
import projectLogAPI from '../services/project-log';
import ShareProject from './ShareProject';
import moment from 'moment';

const Widget = () => {
  const [session] = useSession()
  const { user, setAuthUser, checkPermission, addCustomItem, getCustomItem, removeCustomItem } = useContext(UserContext)
  const [hash, setHash] = useState()
  const [isProjectView, setProjectView] = useState(false)
  const [current, setCurrent] = useState(1)
  const [last, setLast] = useState(1)
  const navigate = useNavigate();
  const location = useLocation();
  const [idProject, setIdProject] = useState()
  const [disableNew, setDisableNew] = useState(false)
  const [aditionalPermissions, setAditionalPermissions] = useState(null)
  const [filtered, setFiltered] = useState(false)
  const [keyword, setKeyword] = useState(null)
  const [projectInformation, setProjectInformation] = useState(null)
  const [invitationsSending, setInvitationsSending] = useState(false)

  const [message, setMessage] = useState('')
  const [messages, setMessages] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize, setPagesize] = useState(10)
  const [sending, setSending] = useState(false)
  const [collaborators, setCollaborators] = useState(0)
  const [total, setTotal] = useState(0)
  const [loadingLog, setLoadingLog] = useState(false)

  const [steps, setSteps] = useState([
    { title: 'Project brief', completed: false },
    { title: 'Invite participants', completed: false }
  ])
  const [selectedTab, setSelectedTab] = useState(steps[0].title)
  const shareComponent = useRef(null) 

  const automaticPayment = async () => {
    let hashIdProject = null;
    // const projectInfo = ev.detail.data
    const projectInfo = projectInformation
    if (user && user.view) {
      hashIdProject = user.view.hash_id_project
    } else if (getCustomItem('bunny.Project')) {
      const storageData = JSON.parse(getCustomItem('bunny.Project'))
      hashIdProject = storageData.hash_id_project
    }

    if (hashIdProject) {
      const data = {
        hash_id_project: hashIdProject,
        hash_id_widget_completed_form: projectInfo.hash_id_completed_form
      }
      await projectAPI.post({jwt: session, payload: data})
      removeCustomItem('bunny.Project')
      navigate(`/widget#project/posted/${projectInfo.hash_id_completed_form}/payment/${projectInfo.hash_id_bill}/success`)
      navigate(0)
    }
  }

  const nextStep = (e) => {
    const projectInfo = e.detail.data
    setProjectInformation(projectInfo)

    toggleCompleted('Project brief')
    setSelectedTab('Invite participants')
  }

  const toggleCompleted = (title) => {
    const updated = steps.map(step => {
      if (step.title === title) {
        return {
          ...step,
          completed: true
        }
      }
      return step
    })
    setSteps(updated)
  }

  const onNewProject = async () => {
    // Create project
    setDisableNew(true)
    const dummyData = {                       // TODO: use dynamic data
      opportunity_code: '12345678',
      fulfillment: 'contest'
    }
    try {
      const res = await projectAPI.structure({ jwt: session, payload: dummyData })
      addCustomItem('bunny.Project', res.data.data)
      setDisableNew(false)
      navigate(`/widget#project`)
      navigate(0)
    } catch (error) {
      console.error(error)
      setDisableNew(false)
    }
  }
  useEffect(() => {
    (async () => {
      try {
        let permissions = undefined;

        if (session && !user) {
          const res = await authAPI.get({ jwt: session })
          const authUser = res.data.data
          permissions = [...authUser.project_permissions, ...authUser.global_permissions]
          setAuthUser(authUser)
        } else if (!user) {
          navigate('/login')
        }

        if (user) {
          permissions = [...user.project_permissions, ...user.global_permissions]     
        }
        const value = location.hash.replace('#', '')
        const projectView = checkProjectView(value)
        if (!projectView) await initWidget(null, permissions)
        // const ele = await waitForElm('widget')
        // ele.addEventListener('bsSubmit', automaticPayment)
      } catch (error) {
        console.log(error)
        navigate('/login')
      }
    })()
    return () => {
      // document.getElementById('widget').removeEventListener('bsSubmit', eventHandler)
    }
  }, [])

  const waitForElm = (selector) => {
    return new Promise(resolve => {
      const checkExit = setInterval(() => {
        if (document.getElementById(selector)) {
          return resolve(document.getElementById(selector));
          clearInterval(checkExit)
        }
      }, 100);
    });
  }

  useEffect(() => {
    const value = location.hash.replace('#', '')
    setHash(value)
    checkProjectView(value)
  }, [location])

  const checkProjectView = (value) => {
    const path = value.split('/')
    if (path.length == 3 && path[0] == 'project' && path[1] == 'posted') {
      setProjectView(true)
      setIdProject(path[2])
      getProjectPermissions(path[2])
      getProjectLog(page, path[2])
      return true
    } else if (path.length == 5 && path[0] == 'project' && path[1] == 'posted' && ['history', 'revision', 'reject'].includes(path[3])) {
      setIdProject(path[2])
      getProjectPermissions(path[2])
      return true
    }
    return false
  }

  const getProjectPermissions = async (hash) => {
    const sessionData = getCustomItem('bunny.Projects')
    if (sessionData && sessionData != 'undefined') {
      const temp = JSON.parse(sessionData)
      const filter = temp.filter(item => item.hash_id_widget_completed_form == hash)
      const project = filter && filter.length > 0 ? filter[0] : null
      if (project) {
        setAditionalPermissions(project.project_permissions)
        await initWidget(null, project.project_permissions)
      }
      return
    } else {
      let permissions = undefined;
      if (session && !user) {
        const res = await authAPI.get({ jwt: session })
        const authUser = res.data.data
        permissions = [...authUser.project_permissions, ...authUser.global_permissions]
      }
      if (user) {
        permissions = [...user.project_permissions, ...user.global_permissions]
      }
      await initWidget(null, permissions)
    }
  }

  const initWidget = async (page = null, permissions = null, keyword = null) => {
    const res = await projectAPI.get({ jwt: session, page })
    const data = res.data.data
    const projects = data.projects && data.projects.length > 0 ? data.projects : undefined
    const { start, limit, total } = data.pagination ? data.pagination : { total: 1, limit: 1 }
    const email = data.email ? data.email : undefined

    setCurrent(start + 1)
    setLast(Math.ceil(total / limit))

    // Save project list in session
    addCustomItem('bunny.Projects', projects)

    const parsedProjects = projects && projects.length > 0 ? projects : null
    renderWidget(email, parsedProjects, permissions, keyword)
    return [projects, email]
  }

  const renderWidget = async (email, projects, permissions, keyword = null) => {
    const person = user ? user : (await authAPI.get({ jwt: session })).data.data 

    const wrapper = document.getElementById('widget-container')
    wrapper.innerHTML = '';

    const widget = document.createElement('be-widget')
    widget.setAttribute('id', 'widget')
    widget.setAttribute('key-value', person.key_bunny_widget)
    if (projects) widget.setAttribute('projects', JSON.stringify(projects))
    if (permissions) widget.setAttribute('permissions', JSON.stringify(permissions))
    email ? widget.setAttribute('client-id', email) : widget.setAttribute('client-id', person.view.email_am) 
    if (person && person.view && person.view.opportunity_code) widget.setAttribute('opportunity-code', person.view.opportunity_code) 
    widget.setAttribute('aditional-info', `[{"key": "q", "value": "${keyword ? keyword : ''}", "attribute": "opportunity_code"}]`)
    if(person.email) widget.setAttribute('logged-user', person.email)
    widget.addEventListener('bsSubmit', nextStep)
    wrapper.appendChild(widget)
  }

  const handleClick = async (event) => {
    const target = event.target;
    const page = Number(target.dataset.page);
    if (Number.isNaN(page)) return false
    if (page === current) return false
    await initWidget(page - 1, [...user.project_permissions, ...user.global_permissions])
  }

  const handleNext = async () => {
    const page = current + 1
    if (page > last) return false
    await initWidget(page - 1, [...user.project_permissions, ...user.global_permissions])
  }

  const handlePrev = async () => {
    const page = current - 1
    if (page < 1) return false
    await initWidget(page - 1, [...user.project_permissions, ...user.global_permissions])
  }

  const onFilter = () => {
    if (filtered) setKeyword(null) 
    const ele = document.getElementById('widget') 
    if (ele) ele.setAttribute('loading', true); 
    initWidget(null, [...user.project_permissions, ...user.global_permissions], filtered ? null : keyword)
    setFiltered(!filtered)
  }

  const paginator = () => {
    const delta = 2;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || i >= left && i < right) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }

  const onTabClick = (title) => {
    if (title === 'Project brief' && selectedTab != 'Project brief') {
      initWidget()
    }

    const filterTab = steps.filter(step => step.title == title)
    if (filterTab.length && filterTab[0].completed) {
      setSelectedTab(title)
    }
  }

  const sendInvitations = async() => {
    let hashIdProject = null;
    setInvitationsSending(true)
    if (user && user.view) {
      hashIdProject = user.view.hash_id_project
    } else if (getCustomItem('bunny.Project')) {
      const storageData = JSON.parse(getCustomItem('bunny.Project'))
      hashIdProject = storageData.hash_id_project
    }
    await shareComponent.current.externalSendInvitations(hashIdProject)
    setInvitationsSending(false)
    automaticPayment()
  }

  const getProjectLog = async(pageNum, id_project = null) => {
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      setLoadingLog(true)
      const response = await projectLogAPI.get({jwt: session, project: id_project ? id_project : idProject, pageSize: pageSize, page: pageNum})
      setMessages(response.data.data.projectLog)
      setTotal(response.data.data.count)
      setCollaborators(response.data.data.collaborators)
      setLoadingLog(false)
    } catch (error) {
      console.error(error)
    }
  }

  const sendMessagess = async () => {
    setSending(true)
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      const payload = {
        hash_id_widget_completed_form: idProject,
        message: message
      }
      const response = await projectLogAPI.post({ jwt: session, payload })
      await getProjectLog(1)
      setPage(1)
      setSending(false)
      setMessage('')
    } catch (error) {
      console.error(error)
      setSending(false)
    }
  } 

  const showMoreChat = async() => {
    setSending(true)
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      const response = await projectLogAPI.get({jwt: session, project: idProject, pageSize: pageSize, page: page+1})
      setMessages(prevState => [...prevState, ...response.data.data.projectLog])
      setSending(false)
      setPage(prevState => prevState+1)
    } catch (error) {
      console.error(error)
      setSending(false)
    }
  }

  return (
    <section className={`${!isProjectView && 'w-1/2 mx-auto'}`} id="project">
      {hash == 'dashboard' ? <div className='flex justify-between items-center mb-9'>
        <h1 className='font-bold text-3xl'>Your projects</h1>
        {user && user.position == 'am' && checkPermission('P-NEW') ? <button type="button" onClick={() => onNewProject()} className='font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-4 py-2 rounded focus:outline-none' disabled={disableNew}>Create new project</button> : ''}
      </div> : ''}
      {hash == 'dashboard' ? <div className='flex justify-end'>
        <input id="email"
          className='block w-2/5 h-9 my-2 mr-4 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
          type="text"
          placeholder="Opportunity code"
          value={keyword ? keyword : ''}
          name="opportunity"
          onChange={ (e) => setKeyword(e.target.value) }
        />
        <button className='flex gap-1 text-[#A7A9B3] items-center text-base font-semibold' onClick={() => onFilter()}>
          {!filtered ? <svg width="24px" height="24px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path fill="#A7A9B3" d="M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z"/>
          </svg> : ''}
          {filtered ? <svg width="24px" height="24px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <polygon fill="#A7A9B3" points="40 16 40 53.828 109.024 136 150.815 136 76.896 48 459.51 48 304 242.388 304 401.373 241.373 464 240 464 240 368 208 368 208 496 254.627 496 336 414.627 336 253.612 496 53.612 496 16 40 16"/>
            <polygon fill="#A7A9B3" points="166.403 248.225 226.864 187.763 204.237 165.135 143.775 225.597 83.313 165.135 60.687 187.763 121.148 248.225 60.687 308.687 83.313 331.314 143.775 270.852 204.237 331.314 226.864 308.687 166.403 248.225"/>
          </svg> : ''}
        </button>
      </div> : ''}
      {/* <div id='widget-container'></div> */}
      {hash == 'project' ? <div>
        <Tabs
          tabs={steps}
          selectedTab={selectedTab}
          onTabClick={title => onTabClick(title)}
        />

        <div className="py-4">
          {selectedTab === 'Project brief' && <div id='widget-container'></div>}
          {selectedTab === 'Invite participants' && <>
            <ShareProject ref={shareComponent} showMore noMargin noBack noParticipants noButton title='Audio Production Form' />
            <CustomButton length={projectInformation.project_data.adLength} disabled={invitationsSending} onClick={() => sendInvitations()}/>
          </>}
        </div>
      </div> : <>{isProjectView ? <div className="grid md:grid-cols-[3fr_2fr] gap-10 mx-20">
        <div id='widget-container'></div>
        <div className="max-h-[calc(100vh_-_122px)] overflow-auto">
          {isProjectView && user && checkPermission('P-SHA', aditionalPermissions) ? <div className='bg-[#F0F0F0] p-4 rounded flex justify-between mb-4 items-center'>
            <p className='font-semibold text-sm text-[#3D3F4B]'>Invite collaborators and viewers to this project</p>
            <button type="button" onClick={() => navigate('../invite-people/' + idProject)} className='px-2 py-1 flex gap-2 items-center font-semibold text-base text-[#FE8C18] rounded focus:outline-none border-[#FE8C18] border bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-200'>Share</button>
          </div> : ''}
          <div className="border-b border-[#D7DDED]">
            <div className="flex justify-between mb-2">
              <div className="font-semibold text-base">Project activity</div>
              <div className="text-[#FE8C18] font-semibold text-sm">{collaborators > 0 ? `${collaborators} collaborator${collaborators > 1 ? 's' : ''}` : ''}</div>
            </div>
            <div className="text-[#A7A9B3] text-sm">Use this space to communicate with other collaborators and get updates about the project’s progress.</div>
              <div className="w-full flex justify-end cursor-pointer my-2" onClick={() => {setPage(1); getProjectLog(1);}}>
                <div className={`rounded-full transition-colors ${loadingLog ? 'bg-gray-300' : ''}`}>
                  <svg version="1.1" className="w-8 h-8" enableBackground="new 0 0 65 65" y="0px" x="0px" viewBox="0 0 65 65">
                    <g>
                      <g fill="#A7A9B3">
                        <path d="m32.5 4.999c-5.405 0-10.444 1.577-14.699 4.282l-5.75-5.75v16.11h16.11l-6.395-6.395c3.18-1.787 6.834-2.82 10.734-2.82 12.171 0 22.073 9.902 22.073 22.074 0 2.899-0.577 5.664-1.599 8.202l4.738 2.762c1.47-3.363 2.288-7.068 2.288-10.964 0-15.164-12.337-27.501-27.5-27.501z" />
                        <path d="m43.227 51.746c-3.179 1.786-6.826 2.827-10.726 2.827-12.171 0-22.073-9.902-22.073-22.073 0-2.739 0.524-5.35 1.439-7.771l-4.731-2.851c-1.375 3.271-2.136 6.858-2.136 10.622 0 15.164 12.336 27.5 27.5 27.5 5.406 0 10.434-1.584 14.691-4.289l5.758 5.759v-16.112h-16.111l6.389 6.388z" />
                      </g>
                    </g></svg>
                </div>
              </div>
          </div>
          <div className="flex flex-col-reverse my-4 max-h-[calc(100%_-_370px)] overflow-auto custom-overflow-y">
            {messages.map(item => <div>
            <div className="flex justify-between text-[#B6B7C0] text-xs">
              <div className="font-semibold overflow-hidden whitespace-nowrap truncate">{item.type == 0 ? 'Project update' : item.role.user.email}</div>
              <div className="overflow-hidden whitespace-nowrap truncate">{moment(item.created_at).format("dddd, DD MMMM YYYY - HH:mm")}</div>
            </div>
            <div className={`flex p-2 ${item.type == 0 ? 'bg-[#FDF2E8]' : 'bg-[#ECECEC]' } rounded-lg mb-4`}>{item.message}</div>
            </div>)}
            {messages.length < total ? 
              <div className="border border-[#FE8C18] text-[#FE8C18] py-2 px-4 rounded-3xl m-auto mb-4 cursor-pointer" onClick={() => sending ? null : showMoreChat()}>Show more</div> : <></>}
          </div>
          <div className="flex justify-between items-center gap-4 py-4 border-t border-[#D7DDED]">
              <textarea id="message"
                className='block w-full my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded resize-none'
                placeholder="Type here"
                name="message"
                rows="3"
                value={message}
                onChange={e => setMessage(e.target.value)}
              ></textarea>
              <button type="button" className='font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-3 py-2 rounded focus:outline-none' onClick={sendMessagess} disable={sending}>
                <span>SEND</span>
              </button>
          </div>
        </div>
      </div> : <div id='widget-container'></div>}</>
      }
      {hash == 'dashboard' ? <nav aria-label="Page navigation">
        <ul className="flex pl-0 list-none rounded justify-center mt-3">
          <li className="page-item">
            <button
              className="ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-[#007bff] bg-white border border-solid border-[#dee2e6] no-underline hover:text-[#0056b3] hover:bg-[#e9ecef] hover:border-[#dee2e6]"
              aria-label="NePreviousxt"
              onClick={() => handlePrev()}
            >
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          {paginator().map((page, index) =>
            <li key={index} className="page-item">
              <button id={"paginator-" + index}
                className={(Number(page) == current ? 'text-[#fff] bg-[#007bff] border-[#007bff] z-[1] ' : 'hover:text-[#0056b3] hover:bg-[#e9ecef] hover:border-[#dee2e6] ') + "ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-[#007bff] bg-white border border-solid border-[#dee2e6] no-underline"}
                data-page={page}
                onClick={(e) => handleClick(e)}
              >
                {page}
              </button>
            </li>
          )}
          <li className="page-item">
            <button
              className="ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-[#007bff] bg-white border border-solid border-[#dee2e6] no-underline hover:text-[#0056b3] hover:bg-[#e9ecef] hover:border-[#dee2e6]"
              aria-label="Next"
              onClick={() => handleNext()}
            >
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav> : ''}
    </section>
  )
}

const Tab = ({ title, index, isSelected, isCompleted, onClick }) => {
  const getClasses = () => {
    if (isSelected) {
      return 'text-black border-t-2 border-black';
    } else if (isCompleted) {
      return 'text-[#FE8C18] border-t-2 border-[#FE8C18]';
    }
    return 'text-gray-400 border-t-2 border-gray-300';
  };

  return (
    <button
      onClick={onClick}
      className={`py-2 ${getClasses()} focus:outline-none text-left`}
    >
      <div>Step {index + 1}</div>
      <div>{title}</div>
    </button>
  );
};

const Tabs = ({ tabs, selectedTab, onTabClick }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {tabs.map((tab, index) => (
        <Tab
          key={tab.title}
          title={tab.title}
          index={index}
          isSelected={tab.title === selectedTab}
          isCompleted={tab.completed}
          onClick={() => onTabClick(tab.title)}
        />
      ))}
    </div>
  );
};

const CustomButton = ({onClick, length, disabled}) => {
  return <div className="grid grid-cols-2 justify-between items-center p-6 border border-gray-500 box-border rounded"> 
      <div>{length}-second audio ad</div> 
      <div className="flex justify-end">
        <button disabled={disabled} type="button" className='font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-6 py-4 rounded focus:outline-none' onClick={onClick}>Submit project</button>  
      </div>
    </div>
}

export default Widget
